import { ISimplifiedIntermediaryParams } from 'api/digifi/IntermediaryApi';
import { intermediaryApi } from 'store/api';
import { apiSlice } from './apiSlice';

export const intermediarySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIntermediary: builder.query<ISimplifiedIntermediaryParams, void>({
      queryFn: async () => {
        try {
          const data = await intermediaryApi.getIntermediary();

          return { data };
        } catch (error) {
          return { error };
        }
      },
    }),
  }),
});

export const {
  useGetIntermediaryQuery,
} = intermediarySlice;
